<div
  *ngIf="open"
  class="cv-stac-backdrop"
  role="dialog"
  aria-modal="true"
  aria-label="STAC items"
  (click)="onBackdropClick($event)"
>
  <div class="cv-stac-modal" (click)="$event.stopPropagation()">
    <div class="cv-stac-modal__header">
      <h3 class="cv-stac-modal__title">{{ dataset?.name ?? 'STAC Items' }}</h3>
      <button type="button" class="cv-stac-modal__close" (click)="close.emit()" aria-label="Close">
        ×
      </button>
    </div>

    <div *ngIf="initialLoading()" class="cv-stac-modal__status">Loading STAC items…</div>
    <div *ngIf="error()" class="cv-stac-modal__status cv-stac-modal__status--error">{{ error() }}</div>

    <ng-container *ngIf="!initialLoading() && !error()">
      <!-- <section class="cv-stac-date-filter" aria-label="Filter Date by">
        <h4 class="cv-stac-date-filter__title">Filter Date by</h4>
        <div class="cv-stac-date-filter__row">
          <lib-charts-date-range-picker
            class="cv-stac-date-filter__picker"
            [ngModel]="draftFromRange()"
            (ngModelChange)="onDraftFromChange($event)"
            placeholder="Start date"
            styleClass="cv-stac-date-filter__date-picker"
            [singleDateMode]="true"
            [disableFutureDates]="false"
            [overlayOnTrigger]="true"
            aria-label="Start date"
          />
          <span class="cv-stac-date-filter__sep">To</span>
          <lib-charts-date-range-picker
            class="cv-stac-date-filter__picker"
            [ngModel]="draftToRange()"
            (ngModelChange)="onDraftToChange($event)"
            placeholder="End date"
            styleClass="cv-stac-date-filter__date-picker"
            [singleDateMode]="true"
            [disableFutureDates]="false"
            [minDate]="endPickerMinDate()"
            [overlayOnTrigger]="true"
            aria-label="End date"
          />
          <button
            type="button"
            class="cv-stac-date-filter__apply-btn"
            [disabled]="!canApplyDateFilter()"
            (click)="applyDateFilter()"
          >
            Apply Filter
          </button>
        </div>
        <p
          *ngIf="dateFilterError() as filterError"
          class="cv-stac-date-filter__error"
          role="alert"
        >
          {{ filterError }}
        </p>
      </section> -->

      <div class="cv-stac-modal__content" [class.cv-stac-modal__content--loading]="pageLoading()">
        <div *ngIf="pageLoading()" class="cv-stac-modal__page-loading" role="status" aria-live="polite">
          Loading page…
        </div>
        <div *ngIf="items().length === 0" class="cv-stac-modal__status">No STAC items found.</div>

        <div *ngIf="items().length > 0" class="cv-stac-table-wrap">
          <table class="cv-stac-table">
            <thead>
              <tr>
                <th scope="col">Date</th>
                <th scope="col">Name</th>
                <th scope="col">Preview</th>
                <th scope="col">Plot</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of items(); trackBy: trackByItemId" class="cv-stac-table__row">
                <td class="cv-stac-table__date">{{ formatItemDateTime(item) }}</td>
                <td class="cv-stac-table__name" [title]="item.id">{{ item.id }}</td>
                <td class="cv-stac-table__action">
                  <button
                    *ngIf="hasThumbnail(item); else previewDisabled"
                    type="button"
                    class="cv-stac-table__btn cv-stac-table__btn--preview"
                    (click)="onPreview(item)"
                  >
                    Preview STAC
                  </button>
                  <ng-template #previewDisabled>
                    <span
                      class="cv-stac-table__btn cv-stac-table__btn--disabled"
                      title="No thumbnail is available to preview"
                    >
                      Preview STAC
                    </span>
                  </ng-template>
                </td>
                <td class="cv-stac-table__action">
                  <button
                    type="button"
                    class="cv-stac-table__btn cv-stac-table__btn--plot"
                    (click)="onPlot(item)"
                  >
                    Plot STAC
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="cv-stac-pagination" *ngIf="items().length > 0">
        <button
          type="button"
          class="cv-stac-table__btn cv-stac-table__btn--plot"
          [disabled]="isFirstPage()"
          (click)="fetchPrevious()"
        >
          Previous
        </button>
        <button
          type="button"
          class="cv-stac-table__btn cv-stac-table__btn--plot"
          [disabled]="!hasNext()"
          (click)="fetchNext()"
        >
          Next
        </button>
      </div>
    </ng-container>
  </div>

  <div
    *ngIf="previewUrl() as url"
    class="cv-stac-preview"
    role="dialog"
    aria-label="Preview STAC Image"
    (click)="closePreview()"
  >
    <div class="cv-stac-preview__panel" (click)="$event.stopPropagation()">
      <h4 class="cv-stac-preview__title">Preview STAC Image</h4>
      <img [src]="url" alt="STAC thumbnail preview" class="cv-stac-preview__img" />
      <button type="button" class="cv-stac-preview__close" (click)="closePreview()">×</button>
    </div>
  </div>
</div>
